module.exports = __webpack_public_path__ + "static/media/goal-vivatv.89cd6102.png";